import React from 'react';
import Shimmer from './Shimmer';

const FooterShimmer = () => {
    return (
        <footer className="text-white mt-auto">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="py-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
                    {/* Logo and Description Section */}
                    <div className="space-y-4">
                        <div className="flex items-center space-x-3">
                            <Shimmer className="w-16 h-16 rounded-lg"/>
                        </div>
                        <div className="space-y-2">
                            <Shimmer className="h-4 rounded w-3/4"/>
                            <Shimmer className="h-4 rounded w-full"/>
                            <Shimmer className="h-4 rounded w-5/6"/>
                        </div>
                    </div>

                    {/* Quick Links Section */}
                    <div>
                        <Shimmer className="h-6 rounded w-32 mb-4"/>
                        <div className="space-y-2">
                            {[...Array(4)].map((_, index) => (
                                <Shimmer key={`link-${index}`} className="h-4 rounded w-24"/>
                            ))}
                        </div>
                    </div>

                    {/* Contact Information Section */}
                    <div>
                        <Shimmer className="h-6 rounded w-32 mb-4"/>
                        <div className="space-y-3">
                            {[...Array(3)].map((_, index) => (
                                <div key={`contact-${index}`} className="flex items-center space-x-3">
                                    <Shimmer className="w-6 h-6 rounded"/>
                                    <Shimmer className="h-4 rounded w-40"/>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Newsletter Section */}
                    <div>
                        <Shimmer className="h-6 rounded w-32 mb-4"/>
                        <div className="space-y-2">
                            <Shimmer className="h-4 rounded w-full"/>
                            <Shimmer className="h-10 rounded w-full mt-4"/>
                            <Shimmer className="h-10 rounded w-full"/>
                        </div>
                    </div>
                </div>

                {/* Copyright Section */}
                <div className="border-t border-gray-800 py-6">
                    <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
                        <Shimmer className="h-4 rounded w-64"/>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default FooterShimmer;